const NS = 'AppReloadDialogCtrl';

export default function AppReloadDialogCtrl(
  $scope
) {
  "ngInject";
  $scope.ok = function () {
    window.location.reload();
  };
}
